import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Card } from "./ui/card";
import axios from "axios";
import { CheckCircle, XCircle, Users } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ShowedUpFeed() {
  const [feed, setFeed] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchFeed();
  }, []);

  const fetchFeed = async () => {
    try {
      const response = await axios.get(`${API}/quitter-mode/showed-up-feed`);
      setFeed(response.data.feed || []);
    } catch (error) {
      console.error("Failed to fetch feed:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Card className="bg-zinc-900/50 border-zinc-800 p-4">
        <div className="flex items-center gap-2 text-zinc-500 mb-3">
          <Users className="h-4 w-4" />
          <span className="text-xs uppercase tracking-wider">Who showed up today</span>
        </div>
        <div className="animate-pulse space-y-2">
          {[1, 2, 3].map((i) => (
            <div key={i} className="h-6 bg-zinc-800 rounded" />
          ))}
        </div>
      </Card>
    );
  }

  if (feed.length === 0) {
    return (
      <Card className="bg-zinc-900/50 border-zinc-800 p-4">
        <div className="flex items-center gap-2 text-zinc-500 mb-3">
          <Users className="h-4 w-4" />
          <span className="text-xs uppercase tracking-wider">Who showed up today</span>
        </div>
        <p className="text-zinc-600 text-sm text-center py-4">
          Be the first to show up today
        </p>
      </Card>
    );
  }

  return (
    <Card className="bg-zinc-900/50 border-zinc-800 p-4">
      <div className="flex items-center gap-2 text-zinc-500 mb-3">
        <Users className="h-4 w-4" />
        <span className="text-xs uppercase tracking-wider">Who showed up today</span>
      </div>
      <div className="space-y-2 max-h-48 overflow-y-auto">
        {feed.map((entry, index) => (
          <motion.div
            key={entry.id || index}
            initial={{ opacity: 0, x: -10 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: index * 0.05 }}
            className="flex items-center justify-between py-1"
          >
            <span className={`text-sm ${entry.showed_up ? 'text-zinc-300' : 'text-zinc-600'}`}>
              {entry.name}
            </span>
            {entry.showed_up ? (
              <CheckCircle className="h-4 w-4 text-green-500" />
            ) : (
              <XCircle className="h-4 w-4 text-zinc-700" />
            )}
          </motion.div>
        ))}
      </div>
      <div className="mt-3 pt-3 border-t border-zinc-800">
        <div className="flex justify-between text-xs text-zinc-600">
          <span>{feed.filter(e => e.showed_up).length} showed up</span>
          <span>{feed.filter(e => !e.showed_up).length} didn't</span>
        </div>
      </div>
    </Card>
  );
}
